import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

function AuthCallback() {
    const location = useLocation();

    useEffect(() => {
        const params = new URLSearchParams(location.search);
        if (params.has("error")) {
            console.log('Error: ', params.get("error"));
            window.opener.postMessage({ type: 'SSO_LOGIN_ERROR', error: params.get("error") }, window.location.origin);
            window.close();
        } else if (params.has("code")) {
            const code = params.get("code");
            const apiUrl = process.env.REACT_APP_API_URL_PROD || '';
            fetch(apiUrl + '/api/provision/get-token-from-auth-code', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({ code: code }),
            })
                .then((response) => response.json())
                .then((data) => {
                    if ("error" in data) {
                        throw new Error(data.error);
                    }
                    const token = data.ssoAccessToken;
                    window.opener.postMessage({ type: 'SSO_LOGIN_SUCCESS', token: token }, window.location.origin);
                    window.close();
                })
                .catch((error) => {
                    console.error('Error getting access token:', error);
                    window.opener.postMessage({ type: 'SSO_LOGIN_ERROR', error: error.message }, window.location.origin);
                    window.close();
                });
        } else {
            console.log('Error: No token found');
            window.opener.postMessage({ type: 'SSO_LOGIN_ERROR', error: 'No token found' }, window.location.origin);
            window.close();
        }
    }, [location]);

    return null;
}

export default AuthCallback;